import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as env } from '@env/environment'
import { Observable } from 'rxjs';
import { Message } from '@models/system';

@Injectable({
    providedIn: 'root'
})
export class PinService {

    headers : HttpHeaders;

    constructor(private http: HttpClient) {

        this.headers = new HttpHeaders({
            'Content-Type':'application/json'
        });
    }

    public post(usr: string): Observable<Message> {
        
        return this.http.post<Message>(env.API_URL + '/pin', {usr: usr}, {headers: this.headers});
    }

    public patch(usr : string, pwd: string, pin : string): Observable<Message> {
        
        return this.http.patch<Message>(env.API_URL + '/pwd', {usr: usr, pwd: pwd, pin: pin}, {headers: this.headers});
    }

    public verify(usr : string, pin : string): Observable<Message> {
        
        return this.http.post<Message>(env.API_URL + '/pin/verify', {usr: usr, pin: pin}, {headers: this.headers});
    }
}

